// Kleine markdown-naar-HTML-renderer voor de rapportageweergave.
// Ondersteunt dezelfde subset als de Word-export (word_export.py):
// koppen, opsommingen, genummerde lijsten, vet en scheidingslijnen.
// Escapet eerst alle HTML zodat modeluitvoer nooit als code kan draaien.

function escapeHtml(tekst) {
  return tekst
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function inline(tekst) {
  return tekst.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
}

export default function markdownNaarHtml(markdown) {
  const regels = escapeHtml(markdown || '').split('\n');
  const html = [];
  let lijst = null; // 'ul' | 'ol' | null

  const sluitLijst = () => {
    if (lijst) {
      html.push(`</${lijst}>`);
      lijst = null;
    }
  };

  for (const ruw of regels) {
    const regel = ruw.trimEnd();
    if (!regel.trim()) { sluitLijst(); continue; }

    const kop = regel.match(/^(#{1,4})\s+(.*)$/);
    if (kop) {
      sluitLijst();
      const n = kop[1].length;
      html.push(`<h${n}>${inline(kop[2])}</h${n}>`);
      continue;
    }
    if (/^-{3,}$/.test(regel.trim())) {
      sluitLijst();
      html.push('<hr />');
      continue;
    }
    const bullet = regel.match(/^\s*[-*]\s+(.*)$/);
    if (bullet) {
      if (lijst !== 'ul') { sluitLijst(); html.push('<ul>'); lijst = 'ul'; }
      html.push(`<li>${inline(bullet[1])}</li>`);
      continue;
    }
    const genummerd = regel.match(/^\s*\d+\.\s+(.*)$/);
    if (genummerd) {
      if (lijst !== 'ol') { sluitLijst(); html.push('<ol>'); lijst = 'ol'; }
      html.push(`<li>${inline(genummerd[1])}</li>`);
      continue;
    }
    sluitLijst();
    html.push(`<p>${inline(regel)}</p>`);
  }
  sluitLijst();
  return html.join('\n');
}
